module.exports = __webpack_public_path__ + "static/media/empty-cart.e2103347.png";